import { jobDetailsPayloadType, jobsPayloadType } from 'type/JobsType';
import { apiHeaderOptions } from './apiHeaderOptions';
import api from 'api';


const fetchJobs: any = async (payload: jobsPayloadType) => {
  const { userId, pageNumber, sortType, sortColumn,rpp =10, searchKeyword } = payload;
  const url = api.config.getJobStatus(
    userId,
    pageNumber,
    sortType?.toUpperCase(),
    sortColumn,
    rpp,
    searchKeyword
  );
  const requestOptions = apiHeaderOptions();
  return fetch(url, requestOptions);
};

const fetchJobDetails = async (payload: jobDetailsPayloadType) => {
  const { bulkUploadId, pageNumber, sortType, sortColumn, rpp =10, status, searchKeyword } = payload;
  const url = api.config.getJobDetail(
    bulkUploadId,
    pageNumber,
    sortType?.toUpperCase(),
    sortColumn,
    rpp,
    status,
    searchKeyword
  );
  const requestOptions = apiHeaderOptions();
  return fetch(url, requestOptions);
};

export const jobService = {
  fetchJobs,
  fetchJobDetails
};
